import {Component} from '@angular/core';
import {stepperConfig} from '../config/export/stepper-config';
import {StepperReadyEvent} from '../../../../projects/mydocma/import-export/src/lib/stepper/events/stepper-ready.event';
import {StepperConfig} from '../../../../projects/mydocma/import-export/src/lib/stepper/stepper.config';
import {ExecutionItem} from '../../../../projects/mydocma/import-export/src/lib/stepper/execution/execution-item';
import {ExecutionStateEnum} from '../../../../projects/mydocma/import-export/src/lib/stepper/execution/execution-state.enum';

@Component({
    selector: 'app-expert-stepper',
    templateUrl: './app-export-stepper.component.html',
    styleUrls: ['./app-export-stepper.component.scss']
})
export class AppExportStepperComponent {

    public stepperConfig: StepperConfig = stepperConfig;

    public stepperData: StepperReadyEvent;

    public items = [
        new ExecutionItem({
            name: 'export',
            text: 'Exporting is in progress...',
            icon: 'done',
            progress: 30
        })
    ];

    public exportItems = [
        {
            firstName: 'Yura',
            lastName: 'Gagarin',
            birth: '12.11.1993',
            age: 30,
            userName: 'qwert13',
            nationality: 'Ukrainian'
        },
        {
            firstName: 'Michael',
            lastName: 'Peterson',
            birth: '11.11.1993',
            age: 25,
            userName: 'Resist223',
            nationality: 'Estonian'
        },
        {
            firstName: 'Kendrick',
            lastName: 'Lamar',
            birth: '10.11.1993',
            age: 34,
            userName: 'tushe22',
            nationality: 'Mexican'
        },
        {
            firstName: 'Yulia',
            lastName: 'Ovchinnikova',
            birth: '09.11.1993',
            age: 24,
            userName: 'okWithThat',
            nationality: 'Chinese'
        },
        {
            firstName: 'Yura',
            lastName: 'Gagarin',
            birth: '12.11.1993',
            age: 30,
            userName: 'qwert13',
            nationality: 'Ukrainian'
        },
        {
            firstName: 'Michael',
            lastName: 'Peterson',
            birth: '11.11.1993',
            age: 25,
            userName: 'Resist223',
            nationality: 'Estonian'
        },
        {
            firstName: 'Kendrick',
            lastName: 'Lamar',
            birth: '10.11.1993',
            age: 34,
            userName: 'tushe22',
            nationality: 'Mexican'
        },
        {
            firstName: 'Yulia',
            lastName: 'Ovchinnikova',
            birth: '09.11.1993',
            age: 24,
            userName: 'okWithThat',
            nationality: 'Chinese'
        },
        {
            firstName: 'Yura',
            lastName: 'Gagarin',
            birth: '12.11.1993',
            age: 30,
            userName: 'qwert13',
            nationality: 'Ukrainian'
        },
        {
            firstName: 'Michael',
            lastName: 'Peterson',
            birth: '11.11.1993',
            age: 25,
            userName: 'Resist223',
            nationality: 'Estonian'
        },
        {
            firstName: 'Kendrick',
            lastName: 'Lamar',
            birth: '10.11.1993',
            age: 34,
            userName: 'tushe22',
            nationality: 'Mexican'
        },
        {
            firstName: 'Yulia',
            lastName: 'Ovchinnikova',
            birth: '09.11.1993',
            age: 24,
            userName: 'okWithThat',
            nationality: 'Chinese'
        },
        {
            firstName: 'Yura',
            lastName: 'Gagarin',
            birth: '12.11.1993',
            age: 30,
            userName: 'qwert13',
            nationality: 'Ukrainian'
        },
        {
            firstName: 'Michael',
            lastName: 'Peterson',
            birth: '11.11.1993',
            age: 25,
            userName: 'Resist223',
            nationality: 'Estonian'
        },
        {
            firstName: 'Kendrick',
            lastName: 'Lamar',
            birth: '10.11.1993',
            age: 34,
            userName: 'tushe22',
            nationality: 'Mexican'
        },
        {
            firstName: 'Yulia',
            lastName: 'Ovchinnikova',
            birth: '09.11.1993',
            age: 24,
            userName: 'okWithThat',
            nationality: 'Chinese'
        }
    ];

    public onReadyEvent(param: StepperReadyEvent) {
        this.stepperData = param;
    }

    public onExportEvent() {
        this.stepperData.executionService.start(this.items);

        setTimeout(() => {
            this.items[0].text = 'Exporting was successful';
            this.items[0].state = ExecutionStateEnum.Completed;
        }, 1500);
    }
}
